// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["defaultVendors-node_modules_core-js_modules_es_array-buffer_constructor_js-node_modules_core--dce1e4"], function() { return __webpack_require__(0); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
